import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const ResendVerification = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // If user is already verified, redirect to dashboard
  React.useEffect(() => {
    if (user && user.verified) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const handleResendEmail = async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      await api.post('/auth/resend-verification');
      setMessage('Verification email sent successfully! Please check your inbox.');
    } catch (err) {
      console.error('Error resending verification:', err);
      setError(err.response?.data?.error || 'Failed to resend verification email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-8">
          <div className="text-center mb-6">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
              <svg className="h-6 w-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Email Verification</h2>
            <p className="text-gray-600">
              Your email address needs to be verified before you can book sessions.
            </p>
          </div>

          {/* Success Message */}
          {message && (
            <div className="mb-4 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-md text-sm">
              {message}
            </div>
          )}

          {/* Error Message */}
          {error && (
            <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-gray-900 mb-2">What to do:</h3>
              <ol className="text-sm text-gray-700 space-y-2 list-decimal list-inside">
                <li>Click the button below to receive a new verification email</li>
                <li>Check your inbox (and spam folder) for an email from VibeyFocus</li>
                <li>Click the verification link in the email</li>
                <li>You'll be redirected back and ready to book sessions!</li>
              </ol>
            </div>

            <button
              onClick={handleResendEmail}
              disabled={loading}
              className="w-full px-4 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium"
            >
              {loading ? 'Sending...' : 'Resend Verification Email'}
            </button>

            <Link
              to="/dashboard"
              className="block w-full text-center px-4 py-2 text-gray-700 hover:text-gray-900 text-sm font-medium"
            >
              Back to Dashboard
            </Link>
          </div>
        </div>
    </div>
  );
};

export default ResendVerification;
